import { createAsyncThunk, createSlice, SerializedError } from "@reduxjs/toolkit";
import { getProfiles } from "../api/platform";

export const getProfilesEvents = createAsyncThunk(
  "profiles/getProfilesEvents",
  async (params :any) => {
    //type: "email" | "courses"| "full"
    const response = await getProfiles(params);
    return response;
  }
);

interface ProfilesState {
  profileData: any;
  isLoading: boolean;
  error: SerializedError | null;
}

const initialState: ProfilesState = {
  profileData: null,
  isLoading: false,
  error: null,
};

const profileSlice = createSlice({
  name: "profiles",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProfilesEvents.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getProfilesEvents.fulfilled, (state, action) => {
        state.isLoading = false;
        state.profileData = action.payload;
      })
      .addCase(getProfilesEvents.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error; 
      });
  },
});

export default profileSlice.reducer;
